import { ImageUpload } from '../../../components/Media/ImageUpload';
import { TanstackFieldError } from '../TanstackFieldError';
import { useFieldContext } from '../formContext';

type Props = {
  maxSize?: number;
  accept?: Record<string, string[]>;
  label?: string;
  currentImageUrl?: string | null;
};

export const TanstackFormImageUpload = ({ maxSize, accept, label, currentImageUrl }: Props) => {
  const field = useFieldContext<File | null | undefined>();

  return (
    <div className='flex flex-col gap-4'>
      <ImageUpload
        onFileSelect={(file) => field.handleChange(currentImageUrl ? (file ?? undefined) : file)}
        onRemove={currentImageUrl ? () => field.handleChange(null) : undefined}
        maxSize={maxSize}
        accept={accept}
        label={label}
        currentImageUrl={currentImageUrl}
      />
      <TanstackFieldError field={field} />
    </div>
  );
};
